<template>
  <v-dialog v-model="dialog" persistent width="1300">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>picture_as_pdf</v-icon>Visualizar documento
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn flat icon title="Ver en otra ventana" @click="openNewWindow()">
          <v-icon>fullscreen</v-icon>
        </v-btn>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex>
            <embed
              :src="url"
              type="application/pdf"
              width="100%"
              height="700px"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  // Variables iniciales
  data() {
    return {
      dialog: false,
      loading: false,
      url: "",
      api_backend: ""
    };
  },
  mounted() {
    this.$bus.$on("openDialogReporte", item => {
      console.log(item);
      this.url = item;
      this.api_backend = process.env.API_URL.split("api/");
      this.dialog = true;
    });
  },
  methods: {
    close() {
      this.loading = false;
      this.dialog = false;
    },
    openNewWindow() {
      window.open(this.url);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/dialogs/Reporte.vue